import { DomainType } from '../../utilities/domain.utility';
import { ActivitySource } from './activity.sharing';

export function activitySourceFormDomainType(domainType: DomainType) {

    const safeDomainType = domainType ?? DomainType.Tenant;

    const domainTypes = {
        [DomainType.ClientPortal]: ActivitySource.ClientPortal,
        [DomainType.ContractorPortal]: ActivitySource.ContractorPortal,
        [DomainType.Mobile]: ActivitySource.Mobile,
        [DomainType.Tenant]: ActivitySource.Tenant
    }

    return domainTypes[safeDomainType];
}